import type { Category } from './valueObjects/category';
import type { ContentAttachment } from './valueObjects/contentAttachment';
import type { ContentS3Path } from './valueObjects/contentS3Path';
import type { Title } from './valueObjects/title';
import type { ContentJson } from '@/types/domain/notice/entities/contentEntity';

import { EntityPvt } from '@/domain/entityPvt';
import { EntityNamePvt } from '@/types/common/entityPvt';

/**
 * コンテンツプロパティ
 */
export type ContentProps = {
  /** S3パス */
  s3Path: ContentS3Path,
  /** カテゴリ */
  category: Category,
  /** タイトル */
  title: Title,
  /** 添付 */
  attachment: ContentAttachment,
}

/**
 * コンテンツEntity
 */
export class ContentEntity extends EntityPvt<
  ContentProps,
  ContentJson
> {
  toJsonData(): ContentJson {
    const attachment = {
      name: this.attachment.name,
      content: this.attachment.content,
    };
    return {
      s3Path: this.s3Path.value,
      category: this.category.value,
      title: this.title.value,
      attachment,
    };
  }

  /**
   * Entity名
   */
  get entityName(): EntityNamePvt {
    return EntityNamePvt.WagakoAppNoticeContentEntity;
  }

  /**
   * Entityキー
   */
  get entityKey(): string {
    return this.s3Path.value;
  }

  /**
   * S3パス
   */
  get s3Path(): ContentS3Path {
    return this._value.s3Path;
  }

  /**
   * S3パス
   */
  set s3Path(s3Path: ContentS3Path) {
    this._value.s3Path = s3Path;
  }

  /**
   * カテゴリ
   */
  get category(): Category {
    return this._value.category;
  }

  /**
   * カテゴリ
   */
  set category(category: Category) {
    this._value.category = category;
  }

  /**
   * タイトル
   */
  get title(): Title {
    return this._value.title;
  }

  /**
   * タイトル
   */
  set title(title: Title) {
    this._value.title = title;
  }

  /**
   * 添付
   */
  get attachment(): ContentAttachment {
    return this._value.attachment;
  }

  /**
   * 添付
   */
  set attachments(attachment: ContentAttachment) {
    this._value.attachment = attachment;
  }
}
